import * as Yup from 'yup'

export const schemaProfileItem = (t: (key: string) => string) => ({
  email: Yup.string().required(t('profileFormFieldRequiredMessage')),
  companyName: Yup.string().required(t('profileFormFieldRequiredMessage')),
  phone: Yup.string().required(t('profileFormFieldRequiredMessage')),
})
